import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { setLenisInstance } from "./lenis";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import InformazioniSocietarie from "./pages/InformazioniSocietarie";
import NotFound from "./pages/NotFound";

function LenisBridge() {
  const lenis = useLenis();
  React.useEffect(() => {
    if (lenis) setLenisInstance(lenis);
  }, [lenis]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <LenisBridge />
          <div className="min-h-screen bg-white antialiased">
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/informazioni-societarie" element={<InformazioniSocietarie />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
          <CookieBanner />
          <Toaster position="bottom-right" richColors />
        </ReactLenis>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
